import React, { useEffect, useState } from 'react';
import { MerchantAdvance, merchantAuthAPI } from '../lib/api';

export const MerchantAdvanceCard: React.FC<{ initialAdvance?: MerchantAdvance | null; children?: React.ReactNode }> = ({ initialAdvance, children }) => {
    const [advance, setAdvance] = useState(initialAdvance);
    const [stale, setStale] = useState(false);
    useEffect(() => { setAdvance(initialAdvance); }, [initialAdvance]);
    useEffect(() => {
        let active = true;
        let fetching = false;
        const refresh = async () => {
            if (fetching) return;
            fetching = true;
            try {
                const result = await merchantAuthAPI.getAdvance();
                if (active) { setAdvance(result.advance); setStale(false); }
            } catch {
                if (active) setStale(true);
            } finally { fetching = false; }
        };
        void refresh();
        const interval = setInterval(() => void refresh(), 30000);
        return () => { active = false; clearInterval(interval); };
    }, []);
    if (!advance) return <>{children}</>;
    return <div aria-label="Текущий баланс">
        <p className="text-2xl font-bold tabular-nums text-slate-900 dark:text-slate-100 mb-1">{advance.balance.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDT</p>
        {stale && <p role="status" className="text-xs text-amber-600 dark:text-amber-400 mt-1">Не удалось обновить баланс. Показано последнее полученное значение.</p>}
    </div>;
};
